<template>
  <div id="app">
    <van-notify v-model="show" className="page-notify">
      <div style="width: 100%; text-align: left">
        <van-row>
          <van-col :span="12">
            <van-icon name="bell" style="margin-right: 4px" />
            <span>{{ $t('member.system_message') }}</span>
          </van-col>
          <van-col :span="12" class="txt-right">
            <van-icon name="cross" @click="show = false" />
          </van-col>
        </van-row>
        <div class="page-notify-box">
          <div class="title">{{ tmpNotify.title }}</div>
          <div class="content">
            {{ tmpNotify.content }}
          </div>
        </div>
        <div class="txt-right" @click="toNoticeList">
          <van-icon name="arrow" /><van-icon name="arrow" /><van-icon
            name="arrow"
          />
        </div>
      </div>
    </van-notify>
    <router-view />
    <div class="home-servers-box">
    <van-action-sheet v-model="show_servers" :title="$t('home.menu4')">
      <div style="padding: 30px 0 50px;">
        <van-cell-group>
          <van-cell v-for="(item,index) in actions" :title="$t('home.menu4')+ '-'+(index + 1)" :key="index" is-link @click="onSelect(item)" />
        </van-cell-group>
      </div>
    </van-action-sheet>
    </div>
  </div>
</template>
<script>
import {
  TokenColorKey,
  TokenLangKey,
  setTokenbyName,
  getTokenbyName,
  getToken
} from '@/utils/cookies'
import { customService } from '@/utils/utils'
export default {
  name: 'App',
  provide () {
    return {
      app: this
    }
  },
  data () {
    return {
      show: false,
      tmpNotify: {},
      timer: null,
      timenum: 10000,
      wapConfig: null,
      langval: null,
      show_servers: false,
      actions: []
    }
  },
  watch: {
    show (newvalue) {
      if (!newvalue) {
        if (this.wapConfig.unread_notice_switch == 1) {
          const that = this
          this.$nextTick(() => {
            that.timer = setInterval(() => {
              that.getNotice()
            }, this.timenum)
          })
        }
      }
    }
  },
  created () {
    this.getWapSetting()
    this.langval = getTokenbyName(TokenLangKey)
    if (!this.langval) {
      this.langval = navigator.language || navigator.userLanguage
      if (this.langval.indexOf('zh') > -1) {
        this.langval = 'zh-cn'
      } else {
        this.langval = 'en'
      }
      setTokenbyName(this.langval, TokenLangKey)
    }
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  },
  mounted () {},
  methods: {
    onSelect (item) {
      this.show_servers = false
      this.jumpUrl(item)
    },
    jumpUrl(url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    },
    setWapTheme () {
      const setting = getTokenbyName(TokenColorKey)
      if (setting) {
        if (setting == 'night') {
          document.documentElement.style.setProperty(
            '--background-color',
            '#102030'
          )
          document.documentElement.style.setProperty(
            '--background-color1',
            '#0b1622'
          )
          document.documentElement.style.setProperty('--font-color', '#fff')
        } else {
          document.documentElement.style.setProperty(
            '--background-color',
            '#fff'
          )
          document.documentElement.style.setProperty(
            '--background-color1',
            '#e1e1ea'
          )
          document.documentElement.style.setProperty('--font-color', '#000')
        }
      } else {
        if (
          this.wapConfig &&
          this.wapConfig.theme_switch &&
          this.wapConfig.theme_switch == 1
        ) {
          document.documentElement.style.setProperty(
            '--background-color',
            '#102030'
          )
          document.documentElement.style.setProperty(
            '--background-color1',
            '#0b1622'
          )
          document.documentElement.style.setProperty('--font-color', '#fff')
          setTokenbyName(TokenColorKey, 'night')
        } else {
          document.documentElement.style.setProperty(
            '--background-color',
            '#fff'
          )
          document.documentElement.style.setProperty(
            '--background-color1',
            '#e1e1ea'
          )
          document.documentElement.style.setProperty('--font-color', '#000')
          setTokenbyName(TokenColorKey, 'day')
        }
      }
    },
    getWapSetting () {
      this.$http({
        method: 'get',
        url: 'getSetting'
      }).then(res => {
        this.wapConfig = res.data
        this.$store.commit('sysconfig/SET_CONFIG', this.wapConfig)
        let link = document.createElement('link')
        link.rel = 'icon'
        link.href = this.wapConfig.logo
        link.type = 'image/x-icon'
        document.head.appendChild(link)
        document.title = this.wapConfig.name
        //wapConfig.custom_script

        if (
          this.wapConfig.custom_service &&
          this.wapConfig.custom_service.split(',').length > 0
        ) {
          this.actions = this.wapConfig.custom_service.split(',')
        }

        if (
          this.wapConfig.custom_script &&
          this.wapConfig.custom_script.length > 0
        ) {
          this.initJs()
        }

        if (this.wapConfig.unread_notice_switch == 1) {
          const that = this
          this.$nextTick(() => {
            that.timer = setInterval(() => {
              that.getNotice()
            }, this.timenum)
          })
        }
        this.setWapTheme()
        this.$forceUpdate()
      })
    },
    initJs () {
      customService(this.wapConfig)
    },
    getNotice () {
      const token = getToken()
      const pageName = this.$route.name
      if (token && token.length > 0 && pageName != 'notify' && !this.show) {
        this.getNoticeList()
      }
    },
    async getNoticeList () {
      await this.$http({
        method: 'post',
        url: 'getNoticeList',
        data: {
          page: 1,
          limit: 1
        }
      }).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.show = res.data.list[0].status == 1
          this.tmpNotify = res.data.list[0]
          if (this.show) {
            if (this.timer) clearInterval(this.timer)
          }
        }
      })
    },
    toNoticeList () {
      this.show = false
      this.$router.push({ name: 'notify' }, () => {})
    }
  }
}
</script>

<style lang="scss"></style>
